<template>
  <div>
    <data-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="addNewDataSidebar = false"
      :options="addObj"
      @ok="addAccount"
    />

    <vs-table ref="table" :max-items="itemsPerPage" :data="dataTransformed">
      <div slot="header" class="w-full">
        <div class="flex flex-wrap-reverse items-center">
          <!-- ADD NEW -->
          <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="addNewDataSidebar = true"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Add New</span>
          </div>

          <!-- Search -->
          <!-- <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-warning border border-solid border-warning"
            @click="searchPrompt = true"
          >
            <feather-icon icon="SearchIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base">Search</span>
          </div> -->

          <!-- <vs-prompt
            title="Search"
            @cancel="val = ''"
            @accept="searchQuery"
            @close="searchPrompt = false"
            :active.sync="searchPrompt"
          >
            <div class="con-exemple-prompt">
              <span>Enter a Phone# or Email to search</span>
              <vs-input
                @keyup.enter="searchQuery"
                placeholder="eg. john@company.com,Company Name...."
                vs-placeholder="eg. john@company.com,416499...."
                v-model="query"
                class="mt-3 w-full"
              />
            </div>
          </vs-prompt> -->
        </div>

        <!-- <div
          class="flex justify-between py-3 px-4 rounded"
          style="background:#eee"
          v-if="searchedTerm"
        >
          <span>
            Showing {{ searchResults.length }} results for
            <b>"{{ searchedTerm }}"</b>
          </span>
          <vs-button size="small" color="warning" @click.native="clearSearch"
            >Clear Search</vs-button
          >
        </div> -->

        <!-- ITEMS PER PAGE -->
      </div>

      <template slot="thead">
        <!-- <vs-th sort-key="name">Name</vs-th> -->
        <vs-th >Email</vs-th>
        <vs-th sort-key="name">Name</vs-th>
        <vs-th>Role</vs-th>
        <vs-th sort-key="">Confirmed</vs-th>
        <vs-th sort-key=""></vs-th>
        <!-- <vs-th sort-key="order_status">Confirmed</vs-th> -->
        <!-- <vs-th sort-key="price">Price</vs-th> -->
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <!-- <vs-td>
              <router-link
                :to="`/account/${tr.id}`"
                class="product-name font-medium"
                >{{ tr.username }}</router-link
              >
            </vs-td> -->

            <vs-td>
              <p class="product-category">{{ tr.user.email }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              {{ tr.user.role.name }}
              <!-- <vs-progress :percent="Number(tr.popularity)" :color="getPopularityColor(Number(tr.popularity))" class="shadow-md" /> -->
            </vs-td>
            <vs-td>
              {{ tr.user.confirmed }}
            </vs-td>
            <vs-td>
              <vs-button
                @click.native="deleteUser(tr)"
                radius
                color="danger"
                type="filled"
                icon-pack="feather"
                size="small"
                icon="icon-trash"
              ></vs-button>
            </vs-td>

            <!-- <vs-td>
                <vs-chip :color="getOrderStatusColor(tr.user.confirmed)" class="product-order-status">{{ tr.user.confirmed ? 'Yes' : 'No' }}</vs-chip>
              </vs-td> -->

            <!-- <vs-td>
                <p class="product-price">${{ tr.price }}</p>
              </vs-td> -->
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <!-- <vs-pagination
      class="mt-3"
      :total="max"
      v-model="currentPage"
    ></vs-pagination> -->
  </div>
</template>

<script>
import DataSidebar from "@/components/DataSidebar.vue";
import { $loading } from "@/assets/helper";
export default {
  components: {
    DataSidebar
  },
  data() {
    return {
      searchPrompt: false,
      query: "",
      currentPage: 1,
      totalAccounts: 0,
      searchedTerm: "",
      searchResults: [],
      clientUsers: [],

      selected: [],
      users: [],
      itemsPerPage: 10,
      isMounted: false,
      addNewDataSidebar: false,

      addObj: {
        api: "custom",
        apiType: "accounts",
        label: "User",
        selectClientRole: true,
        role: "",
        fields: [
          {
            label: "Email",
            type: "email",
            field: "email",
            required: true
          },
          {
            label: "Name",
            type: "name",
            field: "name",
            required: true
          }
        ]
      }
    };
  },
  async created() {
    // let query = { parentId: 234234 };
    console.log(this.$store.state);

    await this.getClientUsers();
  },
  computed: {
    dataTransformed() {
      if (this.searchedTerm) return this.searchResults;
      return this.clientUsers;
    }
  },
  methods: {
    async getClientUsers() {
      let accountId = this.$store.state.currentAccount.id;
      console.log(accountId);
      let { data } = await this.$get(`/accounts/users/${accountId}`);
      this.clientUsers = data;
      console.log(this.clientUsers);
    },
    addAccount(obj) {
      $loading();
      // console.log("ADDING ACCOUNT", obj);
      this.$create("/accounts/users", obj)
        .then(({ data }) => {
          console.log(data);
          this.getClientUsers();
          this.addNewDataSidebar = false;
          this.$vs.dialog({
            color: "success",
            title: `Account Created`,
            text: `You have sucessfully created the user: ${
              data.name
            }. An email has been dispatched to ${data.user.email ||
              "Unknown@email.com"} with login details.`
            // accept: () => this.$router.push(`/account/${data.id}`)
          });
        })
        .finally(() => {
          $loading.close();
        });
    },
    deleteUser(client) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm Deletion`,
        text:
          "You are about to delete this user. Please confirm that this is the action you want to perform.",
        accept: () => this.acceptDelete(client.id)
      });
    },
    async acceptDelete(clientId) {
      console.log(clientId);
      this.$delete(`/accounts/users/${clientId}`)
        .then(({ data }) => {
          this.getClientUsers();
          this.$vs.notify({
            color: "danger",
            title: "Deleted!",
            text: `The selected item was successfully deleted`
          });

          // let idx = this.$data[where].findIndex(x => x.id === what.id)
        })
        .catch(err => {
          console.error("ERROR", err);
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
